import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO_RESPONSE__grid2d_download_images } from '@shared/dto/grid2d/_requests/DTO_RESPONSE__grid2d_download_images';
import { RequestGrid2dDownloadImages } from '@shared/dto/grid2d/_requests/request_grid2d_download_images';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { timestamp_ms } from '@shared/utils/utils_time';
import JSZip from 'jszip';
import { STATE__grid2d } from '../STATE__grid2d';

export const remote_grid2d_download_images = createAsyncThunkSafe<DTO_RESPONSE__grid2d_download_images, RequestGrid2dDownloadImages>(
  ENUM__network_event_client_to_server.GRID2D_DOWNLOAD_IMAGES,
  async (request): Promise<DTO_RESPONSE__grid2d_download_images> => {
    return await send_to_server<DTO_RESPONSE__grid2d_download_images>(ENUM__network_event_client_to_server.GRID2D_DOWNLOAD_IMAGES, request);
  },
);

export function init_remote_grid2d_download_images(builder: ActionReducerMapBuilder<STATE__grid2d>) {
  builder
    .addCase(remote_grid2d_download_images.pending, (state, action) => {
      let request = action.meta.arg;

      state.grid2d_images_download_in_progress.add(request.grid2d_id);
    })
    .addCase(remote_grid2d_download_images.rejected, (state, action) => {})
    .addCase(remote_grid2d_download_images.fulfilled, (state, action: PayloadAction<DTO_RESPONSE__grid2d_download_images>) => {
      let response = action.payload;

      if (!(response instanceof DTO_RESPONSE__grid2d_download_images)) return;

      state.grid2d_images_download_in_progress.delete(response.grid2d_id);

      void create_zip_and_download(response);
    });
}

async function create_zip_and_download(response: DTO_RESPONSE__grid2d_download_images) {
  if (response.images_map.size() == 0) return;

  const zip = new JSZip();

  for (let [image_id, url_relative] of Object.entries(response.images_map.to_object()) as [string, string][]) {
    await add_image_to_zip(zip, image_id, url_relative);
  }

  const content = await zip.generateAsync({ type: 'blob' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(content);
  link.download = `ultimatediffusion.com-${timestamp_ms()}.zip`;
  link.click();
  URL.revokeObjectURL(link.href);
  link.remove();
}

async function add_image_to_zip(zip: JSZip, image_id: string, url_relative: string) {
  assert_string_not_empty(image_id, { context: 'image_id' });
  assert_string_not_empty(url_relative, { context: 'url_relative' });

  const response = await fetch(path_relative_to_absolute(url_relative));
  const blob = await response.blob();
  zip.file(`${image_id}.webp`, blob);
}
